<template>
    <div>
        <app-new-breadcrumb :routesName="this.$t('aboutUsRouteName')"></app-new-breadcrumb>
        <div class="main">
            <div class="description">
                <div class="description-inner">
                <div class="description-text">
                    <h2>{{ $t('aboutUsMain') }}</h2>
                    <p v-html="$t('aboutUsSmaller')"></p>
                </div>
                <div class="description-img">
                    <img src="../../../assets/Profesionalnost.jpg">
                </div>
                </div>
            </div>
            <div class="main-part">
                <div class="page-inner">
                <div class="info">
                    <div class="info-img"><img src="../../../assets/Location_Image.jpg"></div>
                    <div class="info-description">
                        <div class="info-item">
                            <h3>{{ $t("basicInformation") }}</h3>
                            <div>
                                <p><b>{{ $t("address") }}:</b> Ložionička 3, Sarajevo</p>
                            </div>
                            <div>
                                <p><b>{{ $t("transactionAccounts") }}</b></br>{{ $t("mainAccountFIA") }}</br>{{ $t("taxAccontFIA") }}</p>
                            </div>
                            <div class="info-with-btn">
                                <p><b>{{ $t("jib") }}:</b> 4202153990006</p>
                                <div class="download-pdf">
                                    <a href="https://fia.ba/Upload/Dokumenti/FIA-JIB.pdf" target="_blank">{{
                                        $t("downloadDocument") }}</a>
                                </div>
                            </div>
                            <div class="info-with-btn">
                                <p><b>{{ $t("pib") }}:</b> 202153990006</p>
                                <div class="download-pdf">
                                    <a href="https://fia.ba/Upload/Dokumenti/FIA-PIB.pdf" target="_blank">{{
                                        $t("downloadDocument") }}</a>
                                </div>
                            </div>

                            <div class="info-with-btn">
                                <p><b>{{ $t("classificationofActivities") }}:</b></p>
                                <div class="download-pdf">

                                    <a href="https://fia.ba/Upload/Dokumenti/Obavje%C5%A1tenjeOrazvrstavanju.pdf"
                                        target="_blank">{{ $t("downloadDocument") }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="big-card-text">
                    <div class="big-card-text-section-left">
                        <div class="big-card-text-title">
                            <h3>{{ $t("vision") }}</h3>
                        </div>
                        <!-- <p v-html="showFullText1 ? $t('visionPhrases') : truncatedText($t('visionPhrases'))"></p>
                        <button @click="showFullText1 = !showFullText1" class="big-card-text-btn">
                            {{ showFullText1 ? $t("less") : $t("more") }}
                        </button> -->
                        <p v-html="$t('ourVisionFullSentence')"></p>
                    </div>
                    <div class="big-card-text-section-right">
                        <div class="big-card-text-title">
                            <h3>{{ $t("values") }}</h3>
                        </div>
                        <!-- <p v-html="showFullText2 ? $t('valuesText') : truncatedText($t('valuesText'))"></p>
                        <button @click="showFullText2 = !showFullText2" class="big-card-text-btn">
                            {{ showFullText2 ? $t("less") : $t("more") }}
                        </button> -->
                        <p v-html="$t('ourValuesFullSentence')"></p>
                    </div>
                </div>

                <div class="big-card-mission">
                    <div class="big-card-mission-title">
                        <h3>{{ $t("mission") }}</h3>
                    </div>
                    <div class="big-card-mission-grid">
                        <div class="big-card-mission-box" v-for="(item, index) in missionItems" :key="index">
                            <p v-html="$t(item.text)"></p>
                        </div>
                    </div>
                </div>


                <!-- <div class="big-card-text">
                    <div class="big-card-text-section-left">
                        <div class="big-card-text-title">
                            <router-link :to="{ name: $t('other-services') }">
                                <h2>{{ $t("services") }}</h2>
                            </router-link>
                        </div>
                        <p v-html="showFullText3 ? $t('servicesList') : truncatedText($t('servicesList'))"></p>
                        <button @click="showFullText3 = !showFullText3" class="big-card-text-btn">
                            {{ showFullText3 ? $t("less") : $t("more") }}
                        </button>
                    </div>
                    <div class="big-card-text-section-right">
                        <div class="big-card-text-title">
                            <h2>{{ $t("products") }}</h2>
                        </div>
                        <p v-html="showFullText4 ? $t('productsList') : truncatedText($t('productsList'))"></p>
                        <button @click="showFullText4 = !showFullText4" class="big-card-text-btn">
                            {{ showFullText4 ? $t("less") : $t("more") }}
                        </button>
                    </div>
                </div> -->

                <!-- <div class="big-card-text">
                    <div class="big-card-text-section-left">
                        <div class="big-card-text-title">
                            <router-link :to="{ name: $t('other-services') }">
                                <h2>{{ $t("services") }}</h2>
                            </router-link>
                        </div>
                        <p v-html="$t('servicesList')"></p>
                    </div>
                    <div class="big-card-text-section-right">
                        <div class="big-card-text-title">
                            <h2>{{ $t("products") }}</h2>
                        </div>
                        <p v-html="$t('productsList')"></p>
                    </div>
                </div> -->


                <div class="big-card-mission-title">
                    <router-link :to="{ name: $t('other-services') }">
                        <h3 style="margin-bottom: 10px;">{{ $t("services") }}</h3>
                    </router-link>
                </div>
                <div class="column-card">
                    <div class="column-container">
                        <div class="card-item" v-for="(item, index) in services" :key="index">
                            <div class="card-item-header">
                                <div class="icon">
                                    <i class="fa fa-solid fa-desktop"></i>
                                </div>
                                <h3 class="title">{{ item.title }}</h3>
                            </div>
                            <p class="text">{{ item.text }}</p>
                        </div>
                    </div>
                </div>

                <div class="big-card-mission-title">
                    <h3 style="margin-bottom: 10px;">{{ $t("products") }}</h3>
                </div>
                <div class="column-card">
                    <div class="column-container-products">
                        <div class="card-item" v-for="(item, index) in products" :key="index">
                            <div class="card-item-header">
                                <div class="icon">
                                    <i class="fa fa-solid fa-desktop"></i>
                                </div>
                                <h3 class="title">{{ item.title }}</h3>
                            </div>
                            <p class="text">{{ item.text }}</p>
                        </div>
                    </div>
                </div>

                <!-- <div class="big-card-mission-title">
                    <router-link :to="{ name: $t('other-services') }">
                        <h2 style="margin-bottom: 10px;">{{ $t("services") }}</h2>
                    </router-link>
                </div>
                <div class="column-card">
                    <div class="column-container">
                        <div class="card-item" v-for="(item, index) in services" :key="index">
                            <div class="card-item-header">
                            </div>
                            <p class="text-2">{{ item.text }}</p>
                        </div>
                    </div>
                </div> -->

                <div class="big-card-with-btns">
                    <div class="big-card-with-btns-item" v-for="(item, index) in pdfItems" :key="index">
                        <p v-html="item.text"></p>
                        <div class="big-card-with-btns-btn">
                            <a :href="item.link" target="_blank">{{ $t("download") }}</a>
                        </div>
                    </div>
                </div>

                <div class="small-cards">
                    <div class="small-card-item" v-for="item in items" :key="item.title">
                        <a :href="item.link" :target="item.isExternal ? '_blank' : '_self'" class="small-card-title">
                            <div class="background-icon">
                                <i :class="item.icon"></i>
                            </div>
                            <h3>{{ $t(item.title) }}</h3>
                        </a>
                    </div>
                </div>

                <div class="big-card-mission-title">
                    <h3 style="margin-bottom: 10px;">{{ $t("accessToInformations") }}</h3>
                </div>
                <div class="big-card-with-btns">
                    <div class="big-card-with-btns-item" v-for="(item, index) in pdfAccessToInformationsItems"
                        :key="index">
                        <p v-html="item.text"></p>
                        <div class="big-card-with-btns-btn">
                            <a :href="item.link" target="_blank">{{ $t("download") }}</a>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="big-card-more-btns">
                        <button v-on:click="openModal" class="big-card-btn">{{ $t("complimentsAndComplaints")
                        }}</button>
                        <router-link :to="{ name: 'kontaktirajte-nas' }" class="big-card-btn">{{ $t("Contact")
                        }}</router-link>
                    </div>

                    <div v-if="isModalVisible" class="modal-overlay" v-on:click.self="closeModal">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3>{{ $t("complimentsAndComplaints") }}</h3>
                                <button v-on:click="closeModal" class="close-btn">&times;</button>
                            </div>
                            <div class="modal-body">
                                <textarea v-model="comment" :placeholder="$t('ComplimentAndComplaintsFormTitle')"
                                    class="text-question"></textarea>
                                <button v-on:click="handleSubmitFeedback()" :disabled="!comment" class="content-button">
                                    {{ $t("submit") }}
                                </button>
                                <div v-if="successMessage" class="success-message">
                                    {{ successMessage }}
                                </div>
                                <div v-if="errorMessage" class="error-message">
                                    {{ errorMessage }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import Breadcrumb from "../../common/Breadcrumb.vue";

export default {
    data() {
        return {
            breadcrumbItems: [],
            newsContent: null,
            isModalVisible: false,
            comment: '',
            answers: [],
            successMessage: '',
            errorMessage: '',
            items: [
                { title: "organization", icon: "fa fa-solid fa-sitemap", link: "https://fia.ba/PublicUpload/ONamaFileovi/OrganizacijskiDijagramFIA.pdf", isExternal: true },
                { title: "annualReport", icon: "fa fa-solid fa-file", link: "#", isExternal: false },
                { title: "internship", icon: "fa fa-solid fa-graduation-cap", link: this.$router.resolve({ name: this.$t('internshipRouteName') }).href, isExternal: false },
                { title: "publicAnnouncements", icon: "fa fa-solid fa-file-text-o", link: this.$router.resolve({ name: 'contentNew', params: { id: 7286, slug: this.$t('publicAnnouncementsRouteName') } }).href, isExternal: false },
                { title: "newsAboutUsGrid", icon: "fa fa-solid fa-newspaper-o", link: this.$router.resolve({ name: this.$t('newsRouteName'), params: { id: this.getNewsId } }).href, isExternal: false },
                { title: "publicProcurements", icon: "fa fa-solid fa-files-o", link: this.$router.resolve({ name: 'menuDetailsNew', params: { id: 7284, slug: this.$t('publicProcurementsRouteName') } }).href, isExternal: false },
            ],
            showFullText1: false,
            showFullText2: false,
            showFullText3: false,
            showFullText4: false,
            missionItems: [
                { text: this.$t("missionBoxText1") },
                { text: this.$t("missionBoxText2") },
                { text: this.$t("missionBoxText3") },
                { text: this.$t("missionBoxText4") }
            ],
            pdfItems: [
                // { text: this.$t("presentationName"), link: "https://fia.ba/PublicUpload/ONamaFileovi/FIAPrezentacija.pdf" },
                { text: this.$t("presentationName"), link: "" },
                { text: this.$t("FIALawName"), link: "https://fia.ba/PublicUpload/ONamaFileovi/ZakonOFinansijskoInformatičkojAgenciji.pdf" },
                { text: this.$t("registryLawName"), link: "https://fia.ba/PublicUpload/ONamaFileovi/ZakonORegistruFinansijskihIzvjestaja.pdf" }
            ],
            // pdfAccessToInformationsItems: [
            //     { text: this.$t("indexRegisty"), link: "https://resources.fia.ba/file/99059E25-96DE-ED11-8B87-00155D1E1252.pdf" },
            //     { text: this.$t("accessToInfoForm"), link: "https://resources.fia.ba/file/DCDE8951-3E20-EB11-8B7C-00155D1E1137.pdf" },
            //     { text: this.$t("guideForAccessToInfor"), link: "https://resources.fia.ba/file/87B9D4E0-95DE-ED11-8B87-00155D1E1252.pdf" }
            // ],
             pdfAccessToInformationsItems: [
                { text: this.$t("indexRegisty"), link: "https://fia.ba/PublicUpload/IndeksRegistarInformacija.pdf" },
                { text: this.$t("accessToInfoForm"), link: "https://fia.ba/PublicUpload/ObrazacZaPodnosenjeZahtjevaZaPristupInformacijama.pdf" },
                { text: this.$t("guideForAccessToInfor"), link: "https://fia.ba/PublicUpload/VodicZaPristupInformacijama.pdf" }
            ],
            accessInformationsItems: [],
            services: [
                {
                    title: this.$t("aboutUsService1Title"),
                    text: this.$t("aboutUsService1Text")
                },
                {
                    title: this.$t("aboutUsService2Title"),
                    text: this.$t("aboutUsService2Text")
                },
                {
                    title: this.$t("aboutUsService3Title"),
                    text: this.$t("aboutUsService3Text")
                },
                {
                    title: this.$t("aboutUsService4Title"),
                    text: this.$t("aboutUsService4Text")
                },
                {
                    title: this.$t("aboutUsService5Title"),
                    text: this.$t("aboutUsService5Text")
                },
                {
                    title: this.$t("aboutUsService6Title"),
                    text: this.$t("aboutUsService6Text")
                },
                {
                    title: this.$t("aboutUsService7Title"),
                    text: this.$t("aboutUsService7Text")
                },
                {
                    title: this.$t("aboutUsService8Title"),
                    text: this.$t("aboutUsService8Text")
                },
                {
                    title: this.$t("aboutUsService9Title"),
                    text: this.$t("aboutUsService9Text")
                },
                {
                    title: this.$t("aboutUsService10Title"),
                    text: this.$t("aboutUsService10Text")
                },
                {
                    title: this.$t("aboutUsService11Title"),
                    text: this.$t("aboutUsService11Text")
                },
                // {
                //     title: this.$t("aboutUsService12Title"),
                //     text: this.$t("aboutUsService12Text")
                // }
            ],
            products: [
                {
                    title: this.$t("aboutUsProducts1Title"),
                    text: this.$t("aboutUsProducts1Text")
                },
                {
                    title: this.$t("aboutUsProducts2Title"),
                    text: this.$t("aboutUsProducts2Text")
                },
                {
                    title: this.$t("aboutUsProducts3Title"),
                    text: this.$t("aboutUsProducts3Text")
                },
                {
                    title: this.$t("aboutUsProducts4Title"),
                    text: this.$t("aboutUsProducts4Text")
                },
                {
                    title: this.$t("aboutUsProducts5Title"),
                    text: this.$t("aboutUsProducts5Text")
                },
                {
                    title: this.$t("aboutUsProducts6Title"),
                    text: this.$t("aboutUsProducts6Text")
                },
            ]

        }
    },
    components: {
        appNewBreadcrumb: Breadcrumb,
    },
    methods: {
        ...mapActions(["submitFeedback"]),
        getNewsId() {
            let urlToCheck = this.$t("newsRouteName");
            let content = this.getContentByUrl(urlToCheck);
            return content.id;
        },
        openModal() {
            this.isModalVisible = true;
        },

        closeModal() {
            this.isModalVisible = false;
            this.comment = '';
        },
        handleSubmitFeedback() {
            const surveyData = {
                answers: [this.comment],
            };

            this.submitFeedback(surveyData)
                .then(response => {
                    if (response.status !== 200) {
                        this.errorMessage = this.$t('submissionError');
                        setTimeout(() => {
                            this.errorMessage = '';
                        }, 5000);
                    } else {
                        this.successMessage = this.$t('successfulSubmit');
                        setTimeout(() => {
                            this.successMessage = '';
                        }, 5000);
                    }
                })
                .catch(error => {
                    this.errorMessage = this.$t('submissionError');
                    setTimeout(() => {
                        this.errorMessage = '';
                    }, 5000);
                });
        },
        truncatedText(text) {
            return text.length > 50 ? text.substring(0, 50) + "..." : text;
        },
        loadTranslatedData() {
            this.missionItems = [
                { text: this.$t("missionBoxText1") },
                { text: this.$t("missionBoxText2") },
                { text: this.$t("missionBoxText3") },
                { text: this.$t("missionBoxText4") }
            ],
                this.pdfItems = [
                    // { text: this.$t("presentationName"), link: "https://fia.ba/PublicUpload/ONamaFileovi/FIAPrezentacija.pdf" },
                    { text: this.$t("presentationName"), link: "" },
                    { text: this.$t("FIALawName"), link: "https://fia.ba/PublicUpload/ONamaFileovi/ZakonOFinansijskoInformatičkojAgenciji.pdf" },
                    { text: this.$t("registryLawName"), link: "" }
                ],
                this.services = [
                    {
                        title: this.$t("aboutUsService1Title"),
                        text: this.$t("aboutUsService1Text")
                    },
                    {
                        title: this.$t("aboutUsService2Title"),
                        text: this.$t("aboutUsService2Text")
                    },
                    {
                        title: this.$t("aboutUsService3Title"),
                        text: this.$t("aboutUsService3Text")
                    },
                    {
                        title: this.$t("aboutUsService4Title"),
                        text: this.$t("aboutUsService4Text")
                    },
                    {
                        title: this.$t("aboutUsService5Title"),
                        text: this.$t("aboutUsService5Text")
                    },
                    {
                        title: this.$t("aboutUsService6Title"),
                        text: this.$t("aboutUsService6Text")
                    },
                    {
                        title: this.$t("aboutUsService7Title"),
                        text: this.$t("aboutUsService7Text")
                    },
                    {
                        title: this.$t("aboutUsService8Title"),
                        text: this.$t("aboutUsService8Text")
                    },
                    {
                        title: this.$t("aboutUsService9Title"),
                        text: this.$t("aboutUsService9Text")
                    },
                    {
                        title: this.$t("aboutUsService10Title"),
                        text: this.$t("aboutUsService10Text")
                    },
                    {
                        title: this.$t("aboutUsService11Title"),
                        text: this.$t("aboutUsService11Text")
                    },
                    // {
                    //     title: this.$t("aboutUsService12Title"),
                    //     text: this.$t("aboutUsService12Text")
                    // }
                ],
                this.products = [
                    {
                        title: this.$t("aboutUsProducts1Title"),
                        text: this.$t("aboutUsProducts1Text")
                    },
                    {
                        title: this.$t("aboutUsProducts2Title"),
                        text: this.$t("aboutUsProducts2Text")
                    },
                    {
                        title: this.$t("aboutUsProducts3Title"),
                        text: this.$t("aboutUsProducts3Text")
                    },
                    {
                        title: this.$t("aboutUsProducts4Title"),
                        text: this.$t("aboutUsProducts4Text")
                    },
                    {
                        title: this.$t("aboutUsProducts5Title"),
                        text: this.$t("aboutUsProducts5Text")
                    },
                    {
                        title: this.$t("aboutUsProducts6Title"),
                        text: this.$t("aboutUsProducts6Text")
                    },
                ]
        }
    },
    computed: {
        ...mapGetters(["getSelectedLanguage", "getContentById", "getContentByUrl",]),
        columns() {
            const itemsPerColumn = Math.ceil(this.services.length / 2);
            return [
                this.services.slice(0, itemsPerColumn),
                this.services.slice(itemsPerColumn),
            ];
        },

    },
    created() {
        this.getNewsId();
    },
    watch: {
        getSelectedLanguage() {
            this.loadTranslatedData();
        }
    }

}
</script>

<style scoped>
.big-card-text {
    width: 100%;
    border-radius: 15px;
    background-color: var(--secondary-color);
    display: flex;
    flex-direction: row;
    /* padding: 2%; */
    /* gap: 2%; */
    margin-bottom: 2%;
    margin-top: 2%;
    /* overflow: hidden; */
    box-shadow: 0 2px 5px rgba(36, 59, 128, 0.08);
    transition: box-shadow 0.3s ease;
}

.big-card-text:hover {
    box-shadow: 0 8px 20px rgba(36, 59, 128, 0.12);
}

.big-card-text-section-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    padding: 15px;
    background-color: var(--secondary-color);
    border-right: 1px solid var(--light-color);
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
}

.big-card-text-section-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    padding: 15px;
    /* background: #f3f6fc; */
    background-color: var(--secondary-color);
    /* border-radius: 10px; */
    /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); */
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
}

.big-card-text-title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    /* border-bottom: 1px solid var(--main-color); */
    border-bottom: var(--secondary-color-hover) 1px solid;

}

.big-card-text-title i,
.big-card-text-title h3 {
    font-size: 24px;
    color: var(--main-color);
    font-weight: 600;
}

.big-card-text p {
    text-align: justify;
    color: #465481;
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 0;
}

.big-card-text-btn {
    width: 20%;
    background-color: transparent;
    border: var(--main-color) 1px solid;
    color: var(--main-color);
    text-align: center;
    padding: 10px;
    border-radius: .5rem;
    cursor: pointer;
    align-self: flex-end;
}

.big-card-text-btn:hover {
    background-color: var(--main-color);
    color: #fff;
    transition: 0.3s;
    text-decoration: underline;
    text-decoration-color: #fff;
}

.big-card-mission {
    width: 100%;
    border-radius: 15px;
    background-color: var(--secondary-color);
    padding: 15px;
    margin-bottom: 2%;
    box-shadow: 0 2px 5px rgba(36, 59, 128, 0.08);
    text-align: center;
}

.big-card-mission-title h3 {
    font-size: 24px;
    color: var(--main-color);
    margin-bottom: 20px;
    font-weight: 600;
    text-align: left;

}

.big-card-mission-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* 2 columns */
    grid-template-rows: repeat(2, auto);
    /* 2 rows */
    gap: 20px;
}

.big-card-mission-box {
    background: linear-gradient(135deg, #fff 0%, var(--light-color) 100%);
    padding: 20px;
    border-radius: 10px;
    /* box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05); */
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border: 1px solid #E0E6F5;
}

.big-card-mission-box:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08);
}

.big-card-mission-box h3 {
    font-size: 20px;
    color: var(--main-color);
    margin-bottom: 10px;
}

.big-card-mission-box p {
    font-size: 18px;
    color: #465481;
    text-align: center;
    line-height: 20px;
    margin-bottom: 0;
}

.big-card-with-btns {
    width: 100%;
    border-radius: .5rem;
    background-color: var(--secondary-color);
    display: flex;
    flex-direction: column;
    /* padding: 1% 2%; */
    margin-bottom: 2%;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(36, 59, 128, 0.08);
    /* box-shadow: 0 6px 15px rgba(36, 59, 128, 0.08); */
}

.big-card-with-btns-item {
    display: flex;
    padding: 10px;
    align-items: center;
    /* border-bottom: var(--main-color) 1px solid; */
    border-bottom: var(--secondary-color-hover) 1px solid;
    text-align: left;
    transition: background-color 0.3s ease;

}

.big-card-with-btns-item:hover {
    background-color: var(--secondary-color-hover);
}

.big-card-with-btns-item:last-child {
    border-bottom: none;
}

.big-card-with-btns-item p {
    color: #465481;
    font-size: 18px;
    margin-bottom: 0;
    flex: 1;
    font-weight: 600;
}

.big-card-with-btns-btn {
    background-color: transparent;
    border: var(--main-color) 1px solid;
    color: var(--main-color);
    text-align: center;
    padding: 5px;
    border-radius: .5rem;
    transition: all 0.3s ease;

}

.big-card-with-btns-btn,
.big-card-with-btns-btn a {
    text-decoration: none;
    color: var(--main-color);
}

.big-card-with-btns-btn:hover {
    background-color: var(--main-color);
    transform: translateY(-2px);
    color: #fff;
    text-decoration: underline;
    text-decoration-color: #fff;
}

.big-card-with-btns-btn:hover a {
    color: #fff;
}


.big-card-more-btns {
    display: flex;
    gap: 10px;
}

.big-card-btn {
    width: 50%;
    background-color: transparent;
    border: var(--main-color) 1px solid;
    color: var(--main-color);
    text-align: center;
    padding: 16px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 18px;
    transition: all 0.3s ease;
}

.big-card-btn,
.big-card-btn a {
    text-decoration: none;
    display: inline-block;
}

.big-card-btn:hover {
    background-color: var(--main-color);
    transition: color 0.3s ease, background-color 0.3s ease;
}

.big-card-btn:hover,
.big-card-btn:hover a {
    text-decoration: underline !important;
    color: #fff;
}

.big-card-more-btns a:hover {
    text-decoration: none;
    color: white;
}

/*Big cards end*/

/*Middle cards*/
.middle-cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 30px;
    margin-top: 1%;
    margin-bottom: 2%;
}


.middle-card-item {
    width: calc(100%/4 - 30px);
    background-color: var(--secondary-color);
    padding: 1% 2%;
    border-radius: 10px;
    display: flex;
}

.middle-card:nth-last-child(-n+4) {
    margin-right: 0;
}

.middle-card-item i,
.middle-card-item h3 {
    font-size: 24px;
    color: var(--main-color);
    margin-right: 10px;
}

.small-cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 30px;
    margin-top: 2%;
    margin-bottom: 2%;
}

.small-card-item {
    position: relative;
    overflow: hidden;
    padding: 25px;
    background: linear-gradient(135deg, #F4F7FD 0%, #E0E6F5 100%);
    border-radius: 8px;
    box-shadow: 0 6px 15px rgba(36, 59, 128, 0.08);
    transition: transform 0.3s ease;
    width: calc((100% - 60px) / 3);
    border: 1px solid #E0E6F5;


}

.small-card-item:hover {
    transform: scale(1.05);
    box-shadow: 0 12px 20px rgba(36, 59, 128, 0.12);

}

.background-icon {
    position: absolute;
    right: -10px;
    top: -20px;
    font-size: 100px;
    opacity: 0.05;
    color: var(--main-color);
    transform: rotate(10deg);
    transition: all 0.5s ease;
}

.small-card-item:hover .background-icon {
    transform: rotate(15deg) scale(1.3);
    opacity: 0.1;
}

.small-card-title {
    position: relative;
    z-index: 2;
    text-decoration: none;
    display: block;
}

.small-card-title h3 {
    font-size: 24px;
    color: var(--main-color);
    font-weight: 600;
    transition: color 0.3s ease;
}


.small-card-title:hover h2 {
    text-decoration: underline;
    text-decoration-color: var(--main-color);
    font-weight: 600;
}

/*Small cards end*/

/* Info */
.info {
    display: flex;
    background-color: var(--light-color);
    margin-bottom: 1%;
    align-items: stretch;
}

.info-description {
    background-color: var(--secondary-color);
    width: 60%;
    max-height: 400px;
    padding: 30px 30px;
    box-sizing: border-box;
    color: var(--main-color);
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
}

.info-item {
    padding: 8px;
    border-radius: 12px;
    background-color: var(--light-color);
}

.info-item h3 {
    font-size: 24px;
    padding-left: 4%;
    padding-top: 1%;
    font-weight: 600;
}

.info-item p {
    font-size: 18px;
    padding: 1% 4%;
    margin-bottom: 0;
}

.info-img {
    width: 40%;
    display: flex;
    flex: 1;
    align-items: center;
    overflow: hidden;
}

.info-img img {
    width: 100%;
    height: auto;
    max-height: 400px;
    object-fit: cover;
    border-radius: 0;
}


.info-with-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
}

.info-with-btn p {
    margin: 0;
    font-size: 18px;
    flex-grow: 1;
    text-align: left;
}

.download-pdf {
    min-width: 100px;
    height: 30px;
    font-size: 14px;
    padding: 2px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--main-color);
    border-radius: .5rem;
    color: var(--main-color);
    text-align: center;
    white-space: nowrap;
    transition: all 0.3s ease;
}

.download-pdf a {
    color: var(--main-color);
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease;
    padding: 5px;
}

.download-pdf:hover {
    background-color: var(--main-color);
    transition: color 0.3s ease, background-color 0.3s ease;
    /* transform: translateY(-1px); */
}

.download-pdf:hover a {
    color: #fff;
    text-decoration: underline;
    text-decoration-color: #fff;
}

button {
    border: none;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    overflow: hidden;
}

.modal-content {
    background-color: var(--light-color);
    padding: 20px;
    border-radius: 8px;
    max-width: 500px;
    width: 100%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index: 10000;
    color: var(--main-color)
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.close-btn {
    font-size: 24px;
    color: #333;
    background: none;
    border: none;
    cursor: pointer;
}

.close-btn:hover {
    color: #d9534f;
}

.modal-body {
    margin-top: 20px;
}

.text-question {
    width: 100%;
    height: 150px;
    border: #c2c5cb 1px solid;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 20px;
    font-size: 1rem;
    background-color: var(--light-color);
}

.content-button {
    display: inline-block;
    padding: 0.6rem 1.5rem;
    color: var(--main-color);
    background-color: transparent;
    border: 2px solid var(--main-color);
    border-radius: 0.5rem;
    font-weight: 600;
    font-size: 1rem;
    text-decoration: none;
    text-align: center;
    transition: all 0.3s ease;
    cursor: pointer;
    margin-top: auto;
    margin-bottom: 2%;
    float: right;
}

.content-button:hover {
    background-color: var(--main-color);
    color: white;
    transform: translateY(-2px);
}

.success-message {
    /* color: green; */
    font-weight: 500;
    padding: 10px;
    background-color: #e0f7e0;
    /* border: 1px solid green; */
    margin-top: 60px;
    text-align: justify;
    font-size: 18px;
}

.error-message {
    color: red;
    font-weight: bold;
    padding: 10px;
    background-color: #f7e0e0;
    /* border: 1px solid red; */
    margin-top: 60px;
    text-align: justify;
    font-size: 18px;
}


.column-card {
    width: 100%;
    border-radius: .5rem;
    background-color: var(--secondary-color);
    margin-bottom: 2%;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(36, 59, 128, 0.08);
}

.column-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 1fr;
}

.column-container-products {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    /* grid-auto-rows: 1fr; */
}


.column {
    display: grid;
    grid-auto-rows: 1fr;
}

.card-item {
    padding: 10px;
    border-bottom: var(--secondary-color-hover) 1px solid;
    transition: background-color 0.3s ease;
    display: flex;
    flex-direction: column;

}

.card-item:hover {
    background-color: var(--secondary-color-hover);
}

.card-item:last-child {
    border-bottom: none;
}

.card-item-header {
    display: flex;
    align-items: flex-end;
    margin-bottom: 0px;
}

.icon {
    margin-right: 12px;
    color: var(--main-color);
    width: 24px;
    text-align: center;
}

.title {
    color: #465481;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.text {
    color: #465481;
    /* font-size: 14px; */
    margin: 0;
    /* padding-left: 36px; */
}

.text-2 {
    color: #465481;
    font-size: 18px;
    margin: 0;
    font-weight: 600;
    /* padding-left: 36px; */
}

@media only screen and (max-width: 992px) {

    .info {
        flex-direction: column;
        padding: 0%;
        margin-top: 2%;
        margin-bottom: 2%;
    }

    .info-description,
    .info-img {
        width: 100%;
    }

    .info-img img {
        max-height: 400px;
    }

    .info {
        max-height: none;
    }

    .info-with-btn {
        flex-direction: row;
        justify-content: center;
        gap: 15px;
    }

    .info-with-btn p {
        font-size: 18px;
        /* text-align: center; */
        flex-grow: 0;
    }

    .download-pdf {
        width: auto;
        padding: 5px 12px;
        margin-left: auto;
    }

    .column-container,
    .column-container-products {
        grid-template-columns: repeat(2, 1fr);
    }

}

@media only screen and (max-width: 768px) {
    .logo-img-header {
        width: 50%;
    }

    .big-card-more-btns {
        flex-direction: column;
    }

    .big-card-btn {
        width: 100%;
        padding: 7px;
    }

    .big-card-text-btn {
        width: 100%;
        padding: 5px;
    }

    .big-card-with-btns-btn {
        padding: 5px;
    }

    /* .big-card-with-btns-item{
        flex-direction: column;
        text-align: start;
        align-items: flex-start;
    }
    .big-card-with-btns-item p{
        padding: 0% !important;
    } */


    .middle-card-item {
        width: 100%;
    }

    .middle-cards,
    .small-cards {
        flex-direction: column;
        gap: 10px;
    }

    .small-card-item {
        width: 100%;
    }

    .column-container {
        grid-template-columns: 1fr;
    }

    .column-container-products {
        grid-template-columns: repeat(1, 1fr);
    }

}

@media only screen and (max-width: 576px) {

    .info-description {
        padding: 0;
    }

    .info-item {
        width: 100%;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        background-color: var(--secondary-color);
    }

    .info-item p {
        font-size: 14px;
    }

    .info-with-btn {
        flex-direction: column;
        justify-content: center;
        width: 100%;
        text-align: center;
        gap: 1px;
    }

    .info-with-btn p {
        width: 100%;
        /* word-wrap: break-word; */
    }

    .download-pdf {
        width: 100%;
        /* max-width: 200px; */
        margin-top: 0;
        padding: 0px 12px;
    }

    .big-card-with-btns-item {
        flex-direction: column;
        text-align: start;
        align-items: flex-start;
        gap: 5px;
    }

    .big-card-with-btns-item p {
        padding: 0% !important;
    }

    .big-card-with-btns-btn {
        width: 100%;
    }

    .big-card-text {
        display: flex;
        flex-direction: column;
    }
}
</style>
